module.exports = __webpack_public_path__ + "static/img/login2.f0bb608.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/login2.png
// module id = Yh14
// module chunks = 1